import React, { useState, useRef, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Dropzone from "react-dropzone";
import download from "downloadjs";
import crossimg from "../../assets/images/icons/cross.svg";
import BoLoader from "../../helpers/BoLoader";
import DialoguePopup from "../../helpers/DialoguePopup";
import ModelPopup from "../../helpers/ModelPopup";
import IssueBulkCardService from "../../services/cards.services";
import ExportToExcel from "../superadmin/ExportToExcel";
import SearchGridRejectedData from "./SearchGridRejectedData";
import result from "../../middlewareTemp/csd.csv";
import file from "../../middlewareTemp/SampleSuspend.csv";

const BulkSuspendCardExcel = (props) => {
  const [ShowClietErr, setShowClientErr] = useState("d-none");
  const [postedFile, setpostedFile] = useState();
  const [RejectedData, setRejectedData] = useState();
  const [modalShowRejectedData, setModalShowRejectedData] = useState(false);

  const [boloader, setBoLoader] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");

  const errorAndSuccessModl = (heading, body, errIcon) => {
    setModalShow(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(errIcon);
  };

  const onShowModelClearFields = () => {
    if (props.calledfrom !== "cardholderdetails") {
      props.onHide();
    }
  };

  // ------------------ DOWNLOAD FILE ------------------
  const DownloadFile = () => {
    const [errorMsg, setErrorMsg] = useState("");

    const downloadFile = async (file) => {
      try {
        setErrorMsg("");
        return download(file);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setErrorMsg("Error while downloading file. Try again later");
        }
      }
    };

    return (
      <div className="files-container">
        {errorMsg && <p className="errorMsg">{errorMsg}</p>}
        <tr>
          <td>
            <a
              onClick={() => downloadFile(file)}
              style={{
                textAlign: "center",
                color: "blueviolet",
                font: "message-box",
                cursor: "grab",
              }}
            >
              <b>Click Here to Download Sample CSV File.</b> Download CSV
            </a>
          </td>
        </tr>
      </div>
    );
  };

  // ------------------ UPLOAD CSV FILE ------------------
  const UploadCsvFile = () => {
    const [fileSize, setFileSize] = useState("");
    const [isValidFile, setisValidFile] = useState(true);
    const [fileName, setFileName] = useState("");
    const [action, setAction] = useState(null);

    const formatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const handleActionChange = (e) => {
      const value = e.target.value;
      if (value === "true") setAction(true);
      else if (value === "false") setAction(false);
      else setAction(null);
    };

    const onCrossImg = () => {
      setFileName("");
      setisValidFile(true);
    };

    const uploadFileAddClient = () => {
      document.getElementById("AddClientFileUpload").click();
    };

    const onSubmitBulkIssueCard = (e) => {
      const file_data = e.target.files[0];
      if (!file_data) return;
      setBoLoader(true);

      if (action === null) {
        errorAndSuccessModl("Error", "Please Select The Action", "icon-error");
        setBoLoader(false);
        return;
      }

      let reg = /(.*?)\.(csv|xml)$/;
      if (!file_data.name.match(reg)) {
        setisValidFile(false);
        setBoLoader(false);
        return;
      }

      setFileName(file_data.name);
      setFileSize(formatBytes(file_data.size));

      const formdata = new FormData();
      formdata.append("File", file_data);

      IssueBulkCardService.BulkSuspendCard(formdata, null, action)
        .then((response) => {
          setBoLoader(false);
          const rejected = response?.data
          if (rejected?.length > 0) {
            setRejectedData(rejected);
            setModalShowRejectedData(true);
          } else {
            errorAndSuccessModl(
              "Success",
              "Data Saved Successfully",
              "icon-success"
            );
          }
        })
        .catch((error) => {
          setBoLoader(false);
          const msgBody =
            error?.response?.data?.message || "Something Went Wrong";
          errorAndSuccessModl("Error", msgBody, "icon-error");
        });
    };

    const handleOnSubmit = (e) => {
      e.preventDefault();
    };

    return (
      <Form className="search-form" onSubmit={handleOnSubmit}>
        <DownloadFile />

        <div className="form-group">
          <label>Actions*</label>
          <div className="form-controls">
            <select className="form-control no-icon" onChange={handleActionChange}>
              <option value="">Select</option>
              <option value="true">Suspend</option>
              <option value="false">UnSuspend</option>
            </select>
          </div>
        </div>

        {fileName === "" ? (
          <div className="col-md-6">
            <div className="form-group">
              <label>Attach CSV File</label>
              <div className="form-controls">
                <div>
                  <Input
                    type="file"
                    hidden
                    id="AddClientFileUpload"
                    className="form-control"
                    accept=".csv,.xml"
                    name="logo"
                    onChange={onSubmitBulkIssueCard}
                  />
                  <h5
                    className="form-control file-control"
                    onClick={uploadFileAddClient}
                  >
                    <label>Drag files here to upload or </label> Browse file
                  </h5>
                  {!isValidFile && (
                    <span className="help-block has_error">
                      Invalid file format
                    </span>
                  )}
                </div>
                <span className="icon-upload-file _ico">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span>
              </div>
              <span className="fs-12 clr-submarine mt-2 d-block">
                Supported file types XML/CSV file.
              </span>
            </div>
          </div>
        ) : (
          <div className="col-md-6">
            <div className="form-group">
              <div className="bo-file d-flex">
                <div className="file-name">
                  <span className="icon-upload-file _ico">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                  <h5>
                    <span>{fileName}</span>
                  </h5>
                </div>
                <div className="ml-auto file-size" onClick={onCrossImg}>
                  <span>{fileSize}</span>
                  <img
                    className="cross-icon"
                    src={crossimg}
                    onClick={onCrossImg}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Form>
    );
  };

  // ------------------ MAIN RENDER ------------------
  const rendeBulkDebitCard = () => {
    return <UploadCsvFile />;
  };

  return (
    <Fragment>
      <BoLoader loading={boloader} />
      <DialoguePopup
        show={modalShow}
        onHide={() => setModalShow(false)}
        hideallpopups={() => setModalShow(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      />

      <ModelPopup
        key={21}
        show={props.show}
        onHide={onShowModelClearFields}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-76"
        backdrop="static"
        keyboard={false}
        modelbody={rendeBulkDebitCard()}
      />

      <ModelPopup
        show={modalShowRejectedData}
        key={22}
        onHide={() => setModalShowRejectedData(false)}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-86"
        modelbody={
          <Fragment>
            <div className="nav-item ms-auto" role="presentation">
              <ExportToExcel
                Dataset={RejectedData}
                Name="BulkDebit"
                calledfrom="bulkdebit"
              />
            </div>
            <SearchGridRejectedData
              methodname="notes"
              placeholdervalue="Search"
              headersdata={["AMOUNT", "TOKEN ID", "ERROR MESSAGE"]}
              screenname="bulkdebit"
              calledfrom="bulkdebit"
              data={RejectedData}
            />
          </Fragment>
        }
      />
    </Fragment>
  );
};

export default BulkSuspendCardExcel;
